// src/api/blacklist_vehicle/blacklistRequest.js
import API from "../axiosConfig";

const API_URL = "/blacklist"; // Adjust the base URL as needed

// Fetch all blacklisted vehicles
export const fetchBlacklistedVehicles = async (params) => {
  try {
    const response = await API.get(API_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching blacklisted vehicles:", error);
    throw error; // Rethrow error to be handled in the component
  }
};

// Add a vehicle to the blacklist
export const addVehicleToBlacklist = async (vehicleData) => {
  try {
    const response = await API.post(API_URL, vehicleData);
    return response.data;
  } catch (error) {
    console.error("Error adding vehicle to blacklist:", error);
    throw error; // Rethrow error to be handled in the component
  }
};

// Update a vehicle in the blacklist
export const updateBlacklistedVehicle = async (vehicleId, vehicleData) => {
  try {
    const response = await API.put(`${API_URL}/${vehicleId}`, vehicleData);
    return response.data;
  } catch (error) {
    console.error("Error updating blacklisted vehicle:", error);
    throw error; // Rethrow error to be handled in the component
  }
};

// Delete a vehicle from the blacklist
export const deleteBlacklistedVehicle = async (vehicleId) => {
  try {
    const response = await API.delete(`${API_URL}/${vehicleId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting blacklisted vehicle:", error);
    throw error; // Rethrow error to be handled in the component
  }
};

// Fetch only trashed/deleted blacklisted vehicles
export const fetchTrashedBlacklistedVehicles = async (params) => {
  try {
    const response = await API.get(`${API_URL}-only-trashed`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching trashed blacklisted vehicles:", error);
    throw error; // Rethrow error to be handled in the component
  }
};
